const Radio = {
  parts: ["control"],
  baseStyle: { control: { borderColor: "gray.medium" } },
};

export default Radio;
